import { useState } from 'react';
import { TextField, Stack, Button } from '@mui/material';

export interface NoteProps {
	val: string | undefined;
	title: string;
	onSave?: (note: string) => void;
}

export const Note = ({ val, title, onSave }: NoteProps) => {
	const [noteValue, setNoteValue] = useState(val ?? '');
	// const [isEditing, setIsEditing] = useState(false);

	const onNoteChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setNoteValue(e.target.value);
	};

	const onSaveNote = () => {
		if (onSave !== undefined) {
			onSave(noteValue);
		}
	};

	return (
		<>
			<TextField
				fullWidth
				multiline
				value={noteValue}
				rows={4}
				onChange={onNoteChange}
				inputProps={{ maxLength: 1000 }}
				InputProps={{ readOnly: !onSave }}
				placeholder={`Enter ${title.toLowerCase()}...`}
				variant="outlined"
			/>
			{onSave && (
				<Stack direction="row" spacing={2} sx={{ mt: 2 }}>
					<Button variant="contained" onClick={onSaveNote}>
						Save
					</Button>
				</Stack>
			)}
		</>
	);
};
